
<div class="tiles-anchor-points" id="tiles-anchor" #tilesAnchor>
    <span class="tiles-anchor-points__target" id="healthy"></span><span class="tiles-anchor-points__target" id="supported"></span><span class="tiles-anchor-points__target" id="protected"></span>
</div>

<div class="tiles-container" *ngIf="categories$ | async as content">
    <mat-tab-group class="nav nav-tabs" mat-align-tabs="center" [selectedIndex]="clientService.getTileIndex()" (selectedTabChange)="pillarTabChange($event)">
        <ng-container *ngFor="let item of $any(content); trackBy: trackByFn">
            <mat-tab *ngIf="pillars.includes(item.name)">
                <ng-template mat-tab-label>
                    <span [innerHTML]="item.name"></span>
                </ng-template>

                <ng-template matTabContent>
                    <span class="page-loader" *ngIf="item.pagesLoading">
                        <span class="loader">Loading</span>
                    </span>
                    <ng-container *ngIf="item.pages$ | async as pages">
                        <div class="tiles-container__column col-lg-6">
                            <ng-container *ngFor="let page of $any(pages); let isOdd = odd; let isFirst = first; let isLast = last;">
                                <div class="tiles-container__column-item {{'section-' + page.categoryNames[0] | lowercase}}" *ngIf="(isOdd || isFirst) && !isLast">
                                    <core-block-home-tile [block]="page.tile" *ngIf="hasTileBlock(page)"></core-block-home-tile>
                                </div>
                            </ng-container>
                        </div>

                        <div class="tiles-container__column col-lg-6">
                            <ng-container *ngFor="let page of $any(pages); let isEven = even; let isFirst = first; let isLast = last;">
                                <div class="tiles-container__column-item {{'section-' + page.categoryNames[0] | lowercase}}" *ngIf="(isEven && !isFirst) || isLast">
                                    <core-block-home-tile [block]="page.tile" *ngIf="hasTileBlock(page)"></core-block-home-tile>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-template>
            </mat-tab>
        </ng-container>
    </mat-tab-group>
</div>
